/**
 * Code-only product terms for Retention Ops.
 * Import these constants everywhere; do not hardcode product or nav strings in components.
 * This file does not reuse TrailLabels — a Trails rename must not change this product.
 */

export const AcademicLabels = {
    PRODUCT: "Retention Ops",
    SECTION_SCHEDULING: "Section Scheduling",
    INSTRUCTOR_SCHEDULING: "Instructor Scheduling",
    SCHEDULE_VALIDATION: "Schedule Validation",
    CURRICULUM: "Curriculum",
    CATALOG: "Catalog",
    MERGE_RESOLUTION: "When both sides change a field",
    MERGE_OURS: "Keep our values",
    MERGE_SIS: "Take the upload",
    MERGE_REVIEW: "Review each conflict",
    MERGE_KEEP_OURS: "Keep ours",
    MERGE_TAKE_UPLOAD: "Take upload",
    MERGE_CONFLICTS: "Open conflicts",
    /** Short nav label for Whole Student Retention Analytics and Forecasting. */
    RETENTION_FORECAST: "Retention Forecast",
    COMING_SOON: "Coming soon",
} as const;
